var _ = require('underscore');
var Promise = require('bluebird');
var id3 = Promise.promisify(require('id3js'));
var ls = require('local-storage');
var btoa = require('base64-arraybuffer').encode;

const PREFIX = 'PLAYER:';
// black box
const DEFAULT_IMAGE =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCI+CiAgPHJlY3QgeD0iMCIgeT0iMCIgaGVpZ2h0PSI2MCIgd2lkdGg9IjYwIiBzdHlsZT0iZmlsbDpibGFjayIgc3Ryb2tlPSJibGFjayIgLz4KPC9zdmc+';

export default class ID3 {
  constructor(image = DEFAULT_IMAGE, skipCache = false) {
    this.image = image;
    this.skipCache = skipCache;
  }

  get(url) {
    const self = this;
    const cached = ls(self._getKey(url));
    if (
      !self.skipCache &&
      cached &&
      cached.expires &&
      cached.expires > new Date()
    ) {
      return Promise.resolve(cached);
    } else {
      return id3(url)
        .then(function(tags) {
          return self._format(tags);
        })
        .tap(function(tags) {
          ls(self._getKey(url), tags);
        });
    }
  }

  _format(tags) {
    if (!tags) tags = {};
    var formatted = _.pick(tags, 'album', 'artist', 'year');

    if (tags.title) {
      formatted.name = tags.title;
    }

    if (tags.v2 && tags.v2.image) {
      formatted.image =
        'data:' + tags.v2.image.mime + ';base64,' + btoa(tags.v2.image.data);
    } else {
      formatted.image = this.image;
    }

    // Expires 14 days from now
    formatted.expires = new Date();
    formatted.expires.setDate(formatted.expires.getDate() + 14);

    return formatted;
  }

  _getKey(url) {
    return PREFIX + url;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/id3.js